import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import {
  IIntegratedReviewsInfo,
  ISendReviewEmailRequest,
  ISendReviewTextRequest,
} from '../models/integrated-reviews.model';

@Injectable({ providedIn: 'root' })
export class IntegratedReviewsService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/client-portal/integrated-reviews`;

  getInfo(): Observable<IIntegratedReviewsInfo> {
    return this.http.get<IIntegratedReviewsInfo>(`${this.baseUrl}/info`);
  }

  sendEmail(request: ISendReviewEmailRequest): Observable<ISendReviewEmailRequest> {
    return this.http.post<ISendReviewEmailRequest>(`${this.baseUrl}/email`, request);
  }

  sendText(request: ISendReviewTextRequest): Observable<ISendReviewTextRequest> {
    return this.http.post<ISendReviewTextRequest>(`${this.baseUrl}/text`, request);
  }
}
